import React from "react";
import { useI18n } from "@/contexts/LanguageContext";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  const options = [
    { code: "it", label: "IT" },
    { code: "en", label: "EN" },
  ];

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border px-1 py-1"
      style={{ borderColor: "hsl(var(--nvl-border))" }}
      data-testid="language-switcher"
      role="group"
      aria-label="Language"
    >
      {options.map((o) => {
        const active = lang === o.code;
        return (
          <button
            key={o.code}
            type="button"
            onClick={() => setLang(o.code)}
            data-testid={`language-switch-${o.code}`}
            aria-pressed={active}
            className={`px-3 ${compact ? "py-1 text-[11px]" : "py-1.5 text-xs"} tracking-[0.2em] rounded-full font-medium`}
            style={{
              backgroundColor: active ? "hsl(var(--nvl-ink))" : "transparent",
              color: active ? "hsl(var(--nvl-bg))" : "hsl(var(--nvl-ink))",
              transition: "background-color 180ms, color 180ms",
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
